import { setupWorker } from 'msw/browser'

import { env } from '@/env'

import { mockActivateCustomerCard } from './agency/mock-activate-customer-card'
import { mockCreateChainAgencyAddressData } from './agency/mock-create-chain-agency-address-data'
import { mockCreateChainAgencyContactData } from './agency/mock-create-chain-agency-contact-data'
import { mockCreateChainAgencyLegalData } from './agency/mock-create-chain-agency-legal-data'
import { mockCreateChainAgencyResponsibleData } from './agency/mock-create-chain-agency-responsible-data'
import { mockCreateChainAgencyUploadContract } from './agency/mock-create-chain-agency-upload-contract'
import { mockCreateCustomer } from './agency/mock-create-customer'
import { mockCreateCustomerAdditionalContact } from './agency/mock-create-customer-additional-contact'
import { mockCreateCustomerCard } from './agency/mock-create-customer-card'
import { mockCreateCustomerCustomField } from './agency/mock-create-customer-custom-field'
import { mockDeactivateCustomerCard } from './agency/mock-deactivate-customer-card'
import { mockDeactivateCustomerCustomField } from './agency/mock-deactivate-customer-custom-field'
import { mockDeleteCustomerCard } from './agency/mock-delete-customer-card'
import { mockGetAgencyChainAdditionalContacts } from './agency/mock-get-agency-chain-additional-contact'
import { mockGetAgencyChainInfos } from './agency/mock-get-agency-chain-infos'
import { mockGetAgencyChainMainContact } from './agency/mock-get-agency-chain-main-contact'
import { mockGetB2BConfigurations } from './agency/mock-get-b2b-configurations'
import { mockGetCompanies } from './agency/mock-get-companies'
import { mockGetCompanyInfos } from './agency/mock-get-company-infos'
import { mockGetContractPressignedURL } from './agency/mock-get-contract-pressigned-url'
import { mockGetCustomerAdditionalContacts } from './agency/mock-get-customer-additional-contacts'
import { mockGetCustomerCards } from './agency/mock-get-customer-cards'
import { mockGetCustomerContact } from './agency/mock-get-customer-contact'
import { mockGetCustomerCustomFieldTypes } from './agency/mock-get-customer-custom-field-types'
import { mockGetCustomerCustomFields } from './agency/mock-get-customer-custom-fields'
import { mockGetCustomers } from './agency/mock-get-customers'
import { mockGetMyBusinessGetCities } from './agency/mock-get-my-business-cities'
import { mockUpdateAgencyChainResponsibleData } from './agency/mock-update-agency-chain-responsible-data'
import { mockUpdateB2BConfigurations } from './agency/mock-update-b2b-configurations'
import { mockUpdateCustomerAdditionalContact } from './agency/mock-update-customer-additional-contact'
import { mockUpdateCustomerCard } from './agency/mock-update-customer-card'
import { mockUpdateCustomerCustomField } from './agency/mock-update-customer-custom-field'
import { mockUploadContract } from './agency/mock-upload-contract'
import { mockGetRequests } from './batch-reservations/mock-get-requests'
import { mockGetAgenciesStores } from './booking/mock-get-agencies-stores'
import { mockGetCities } from './locales/mock-get-cities'
import { mockActivateDistribution } from './my-business/mock-activate-distribution'
import { mockCreateAgencyCard } from './my-business/mock-create-card'
import { mockCreateDistribution } from './my-business/mock-create-distribution'
import { mockCreateSlipCostumization } from './my-business/mock-create-slip-costumization'
import { mockDeactivateCard } from './my-business/mock-deactivate-card'
import { mockDeactivateSlipCostumization } from './my-business/mock-deactivate-slip-costumization'
import { mockGetCards } from './my-business/mock-get-cards'
import { mockGetDistributions } from './my-business/mock-get-distributions'
import { mockGetPaymentMethods } from './my-business/mock-get-payment-methods'
import { mockGetPMSDistributions } from './my-business/mock-get-pms-distributions'
import { mockGetSlipSections } from './my-business/mock-get-slip-sections'
import { mockGetUserInfo } from './my-business/mock-get-user-info'
import { mockUpdateCard } from './my-business/mock-update-card'
import { mockUpdateDistributions } from './my-business/mock-update-distribution'
import { mockUpdateSlipCostumization } from './my-business/mock-update-slip-costumization'
import { mockCreateOrUpdatePolicy } from './policies/mock-create-policy'
import { mockDeactivatePolicy } from './policies/mock-deactivate-policy'
import { mockGetCompaniesUsingPolicy } from './policies/mock-get-companies-using-policy'
import { mockGetPolicies } from './policies/mock-get-policies'
import { mockGetPolicyById } from './policies/mock-get-policy-by-id'
import { mockSetPolicyAsDefault } from './policies/mock-set-as-default'
import { mockUpdatePolicy } from './policies/mock-update-policy'
import { mockGetBookingRequests } from './requests/mock-get-booking-requests'
import { mockGetBookingVipRequests } from './requests/mock-get-booking-vip-requests'

export const worker = setupWorker(
  mockGetRequests,
  mockCreateDistribution,
  mockGetDistributions,
  mockUpdateDistributions,
  mockGetPMSDistributions,
  mockCreateSlipCostumization,
  mockUpdateSlipCostumization,
  mockDeactivateSlipCostumization,
  mockGetSlipSections,
  mockCreateAgencyCard,
  mockUpdateCard,
  mockGetCards,
  mockGetUserInfo,
  mockGetPaymentMethods,
  mockDeactivateCard,
  mockActivateDistribution,
  mockGetBookingRequests,
  mockGetBookingVipRequests,
  mockGetAgenciesStores,
  mockGetPolicies,
  mockCreateOrUpdatePolicy,
  mockUpdatePolicy,
  mockSetPolicyAsDefault,
  mockDeactivatePolicy,
  mockGetPolicyById,
  mockGetCities,
  mockCreateChainAgencyLegalData,
  mockCreateChainAgencyResponsibleData,
  mockUploadContract,
  mockCreateChainAgencyContactData,
  mockCreateChainAgencyUploadContract,
  mockGetCities,
  mockGetMyBusinessGetCities,
  mockCreateChainAgencyAddressData,
  mockGetUserInfo,
  mockGetAgencyChainMainContact,
  mockGetAgencyChainAdditionalContacts,
  mockGetAgencyChainInfos,
  mockGetCompanies,
  mockUpdateAgencyChainResponsibleData,
  mockGetContractPressignedURL,
  mockCreateCustomer,
  mockGetCompanyInfos,
  mockGetCustomers,
  mockUpdateCustomerAdditionalContact,
  mockCreateCustomerAdditionalContact,
  mockGetCustomerAdditionalContacts,
  mockGetCustomerCustomFieldTypes,
  mockGetCustomerCustomFields,
  mockCreateCustomerCustomField,
  mockUpdateCustomerCustomField,
  mockDeactivateCustomerCustomField,
  mockGetCustomerCards,
  mockUpdateCustomerCard,
  mockCreateCustomerCard,
  mockActivateCustomerCard,
  mockDeactivateCustomerCard,
  mockDeleteCustomerCard,
  mockGetCustomerContact,
  mockGetCompaniesUsingPolicy,
  mockGetB2BConfigurations,
  mockUpdateB2BConfigurations,
)

export async function enableMSW() {
  if (!env.REACT_APP_ENABLE_MSW) {
    return
  }

  await worker.start()
}
